import ordersSaga from '~/sagas/orders/orders.saga';

export default ordersSaga;
